export var breakpointTokens = {
  xs: 320,
  s: 768,
  m: 1024,
  l: 1280,
  xl: 1920
};